export default __webpack_public_path__ + "static/media/tn.9e6d7086.svg";